export default "__VITE_ASSET__3v32y50T__"